import React from "react";
import { X } from "lucide-react";

interface ModalProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  onClose: () => void;
  scroll?: boolean;
}

export const Modal = ({
  title,
  subtitle,
  children,
  onClose,
  scroll = false,
}: ModalProps) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/35 p-4">
    <div className="w-full max-w-2xl overflow-hidden rounded-2xl bg-white shadow-2xl">
      <div className="flex items-start justify-between border-b border-[#E8EDF5] px-8 py-5">
        <div>
          <h2 className="text-xl font-bold text-slate-950">{title}</h2>
          {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
        </div>
        <button
          type="button"
          onClick={onClose}
          className="rounded-lg border border-[#DDE6F1] p-3 text-slate-500 hover:bg-slate-50"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
      <div
        className={`space-y-6 px-8 py-7 ${
          scroll ? "max-h-[70vh] overflow-y-auto" : ""
        }`}
      >
        {children}
      </div>
    </div>
  </div>
);

export const FormField = ({
  label,
  required,
  children,
  className = "",
}: {
  label: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}) => (
  <div className={`block ${className}`}>
    <span className="mb-2 block text-sm font-semibold text-slate-700">
      {label} {required && <span className="text-red-500">*</span>}
    </span>
    {children}
  </div>
);

export const TextInput = ({
  label,
  required,
  value,
  onChange,
  placeholder,
  className = "",
  type = "text",
  disabled = false,
}: {
  label: string;
  required?: boolean;
  value: string | number;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  type?: string;
  disabled?: boolean;
}) => (
  <FormField label={label} required={required} className={className}>
    <input
      type={type}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      className="h-12 w-full rounded-lg border border-[#E2E8F0] px-4 outline-none focus:border-[#f26422] focus:ring-2 focus:ring-orange-100"
    />
  </FormField>
);
